
import axios from 'util/axiosConfig';
import { getErrorMessage } from '../util/ErrorUtils';
import { message } from 'antd'


export const getMrtWorklistAPI = async (payload) => {
    const data = {
        ...payload,
        page: payload.page - 1
    };
    return await axios.post(`/api/v1/mrt/worklist`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const getVisitReportAPI = async (risId, reportId, visitNo) => {
    return await axios.get(`/api/v1/mrt/visit-report`, {
        params: {
            risId,
            reportId,
            visitNo
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, visitReport: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const getMrtParkedAPI = async (payload) => {
    const data = {
        ...payload,
        page: payload.page - 1
    };
    return await axios.post(`/api/v1/mrt/parked`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const saveTechnicianNotesAPI = async (payload) => {
    console.log('payload', payload)
    return await axios.post(`/api/v1/save-technician-notes`, payload)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const updateVisitReportStateAPI = async (data) => {
    return await axios.post(`/api/v1/mrt/update-visit-report-state`, data)
        .then(function (response) {
            if (response.status === 200) {
                return { success: true, visit: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const getMrtSubmittedForverificationAPI = async (payload) => {
    const data = {
        ...payload,
        page: payload.page - 1
    };
    return await axios.post(`/api/v1/mrt/submitted-for-verification`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const getMrtVerifiedVisitsAPI = async (payload) => {
    const data = {
        ...payload,
        page: payload.page - 1
    };
    return await axios.post(`/api/v1/mrt/verified`, data)
        .then(function (response) {
            if (response.status === 200) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const fetchMrtPatientHistoryReportsAPI = async (patientId) => {

    return await axios.get(`/api/v1/mrt/patient-history-reports`, {
        params: {
            patientId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, patientHistoryReports: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}


export const downloadDraftReportAPI = async (reportId, visitNo) => {

    return await axios({
        url: '/api/v1/download-draft-report',
        method: 'GET',
        responseType: 'blob',
        params: {
            reportId
        }
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let fileName = visitNo + '.pdf';
        link.setAttribute('download', fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
    }).catch(function (error) {
        message.error('Failed to download file!');
        return { success: false }
    });
}
